import { useMutation, useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import {
  ReportDocument,
  UpdateReportDocument,
} from '../../../generated/graphql'
import { stripNullValues } from '../../../utils/strip-null-values'
import { ReportForm } from '../report-form'
import { ManageTemplateDialog } from './manage-template-dialog'
import { useTranslation } from 'react-i18next'

export const UpdateTemplateDialog = () => {
  const { id } = useParams()
  const { t } = useTranslation(['reports'])
  const [updateReport, { loading: isLoading }] =
    useMutation(UpdateReportDocument)

  const reportId = Number(id)

  const { data } = useQuery(ReportDocument, {
    variables: {
      reportId,
    },
    fetchPolicy: 'cache-and-network',
  })

  if (!data) return null

  const handleSave = async (formData: ReportForm) => {
    if (!formData.reportname) return
    await updateReport({
      variables: {
        reportId,
        report: stripNullValues(
          {
            reportname: formData.reportname,
            reportdescription: formData.reportdescription,
            forcewarehousefilter: Boolean(formData.forcewarehousefilter),
            reportdefinition: formData.reportdefinition,
            reporttype: formData.reporttype,
          },
          { deleteEmptyStrings: true },
        ),
      },
    })
  }

  return (
    <ManageTemplateDialog
      title={t('manage_template_dialog.update_title')}
      dialogData={data.report}
      name={data.report.reportname}
      onSave={handleSave}
      isLoading={isLoading}
    />
  )
}
